export default "__VITE_ASSET__BZJDtRYw__"